import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ModalBodyStyled = styled.div`
  text-align: center;
  padding: 3rem;
`;

export const TitleStyled = styled.h3`
  margin: 0;
  padding: 2rem;
  letter-spacing: 0.02rem;
  font-size: 2.8rem;
  line-height: 3.6rem;
  color: ${colors.neutral[900]};
`;

export const MessageStyled = styled.p`
  color: ${colors.neutral[900]};
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 0;
  padding-bottom: 3rem;
`;

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
`;
